var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import BaseApiClient from '@/plugins/apis/base-api-client';
var ContentTreeTemplateApiClient = /** @class */ (function (_super) {
    __extends(ContentTreeTemplateApiClient, _super);
    function ContentTreeTemplateApiClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ContentTreeTemplateApiClient.prototype.basePath = function () {
        var companyId = this.companyId;
        return "/companies/" + companyId + "/content_tree_templates";
    };
    ContentTreeTemplateApiClient.prototype.fetchTemplates = function () {
        var client = this.client;
        var url = this.basePath();
        return client.get(url);
    };
    ContentTreeTemplateApiClient.prototype.create = function (params) {
        var url = this.basePath();
        return this.requestActionWithNamedProperty({
            method: 'post',
            url: url,
            data: {
                content_tree_template: params
            },
            hasData: true,
            resourceName: 'content_tree_template',
            actionName: 'POST'
        });
    };
    ContentTreeTemplateApiClient.prototype.update = function (templateId, params) {
        var url = this.basePath() + "/" + templateId;
        return this.requestActionWithNamedProperty({
            method: 'patch',
            url: url,
            data: {
                content_tree_template: this.contentTreeTemplateParams(params)
            },
            hasData: true,
            resourceName: 'content_tree_template',
            actionName: 'UPDATE'
        });
    };
    ContentTreeTemplateApiClient.prototype.destroy = function (templateId) {
        var url = this.basePath() + "/" + templateId;
        return this.requestActionWithNamedProperty({
            method: 'delete',
            url: url,
            resourceName: 'content_tree_template',
            actionName: 'DELETE'
        });
    };
    ContentTreeTemplateApiClient.prototype.contentTreeTemplateParams = function (params) {
        return __assign(__assign({}, params), { content_tree_template_paths_attributes: params.content_tree_template_paths });
    };
    return ContentTreeTemplateApiClient;
}(BaseApiClient));
export default new ContentTreeTemplateApiClient();
